import { namespace } from './namespace';

export const UPDATE_NUMBER = namespace + '/UPDATE_NUMBER';
export const VALIDATE_NUMBER = namespace + '/VALIDATE_NUMBER';
export const VALIDATE_NUMBER_FAILURE = namespace + '/VALIDATE_NUMBER_FAILURE';
export const SAVE_NUMBER = namespace + '/SAVE_NUMBER';
